export enum TrainingLocationOption {
	Cadac,
	OwnLocation,
	OnlineRemote,
	Unknown,
	None,
}
